import type { SelectServerOptions } from "../../Form.types";

export const useSelectFieldFallbackFilter = ({
  serverOptions,
  value,
}: {
  serverOptions?: SelectServerOptions;
  value: any;
}) => {
  if (serverOptions) {
    return {
      items: [
        {
          field:
            typeof serverOptions.valueProp != "function"
              ? serverOptions.valueProp ?? "id"
              : "id",
          operator: "exact",
          value: value,
        },
      ],
    };
  }
  return undefined;
};
